import { EditOtherInformationPanel } from '@features/profile/components/edit-other-information-panel/EditOtherInformationPanel';
import { useProfileNavigation } from '@features/profile/hooks/use-profile-navigation/useProfileNavigation';
import * as React from 'react';

const EditOtherInformationRoute = React.memo((): React.ReactElement => {
  const { navigateToPersonalInformation } = useProfileNavigation();

  return <EditOtherInformationPanel onClose={navigateToPersonalInformation} />;
});

EditOtherInformationRoute.displayName = 'EditOtherInformationRoute';

export { EditOtherInformationRoute };
